<template>
  <div class="pt-10 mx-auto w-full md:w-3/4 xl:w-1/2">
    <p class="font-semibold text-center tracking-wider text-gray-500 text-sm">STEP 1/5</p>
    <p class="mb-4 text-2xl font-semibold text-center tracking-widest">Customer Information</p>
    <CustomerInformationForm />
  </div>
</template>

<script>
import CustomerInformationForm from "~/components/app/CustomerInformationForm";

export default {
  name: "CustomerInformationPage",

  components: {
    CustomerInformationForm,
  }
};
</script>

<style></style>
